import { ADD_MANUAL,ADD_MANUAL_SUCCESS,ADD_MANUAL_ERROR,UPDATE_NEW_MANUAL,UPDATE_NEW_MANUAL_ERROR,
  UPDATE_NEW_MANUAL_SUCCESS,DELETE_MANUAL_BYID,DELETE_MANUAL_SUCCESS,DELETE_MANUAL_ERROR,
  ADD_DRAWING,ADD_DRAWING_SUCCESS,ADD_DRAWING_ERROR,UPDATE_NEW_DRAWING,UPDATE_NEW_DRAWING_ERROR,
  UPDATE_NEW_DRAWING_SUCCESS,DELETE_DRAWING_BYID,DELETE_DRAWING_SUCCESS,DELETE_DRAWING_ERROR,
  MANUAL_URL,MANUAL_BY_CLIENT,MANUAL_DATA_SUCCESS,ALL_MANUAL_DATA_SUCCESS,MANUAL_DATA_ERROR,MANUAL_DATA,
  MANUAL_BY_SITEID,CATEGORY_LIST_SUCCESS,ALL_CATEGORY_DATA_SUCCESS,CATEGORY_LIST_ERROR,CHANGETYPE_LIST_SUCCESS,ALL_CHANGETYPE_DATA,CHANGETYPE_LIST_ERROR,MANUAL_CLIENT_DATA_SUCCESS,CATEGORY_DRAWING_DATA,CATEGORY_DRAWING_DATA_ERROR,CATEGORY_DRAWING_DATA_SUCCESS} from "./actionTypes";

export const getByManualurl = (response) => {
    return {
      type: MANUAL_URL,
      payload: response,
    };
  };
  export const getManualByClientId = (response) => {
    return {
      type: MANUAL_BY_CLIENT,
      payload: response,
    };
  };
  export const getManualBySiteId = (params) => {
    return {
      type: MANUAL_BY_SITEID,
      payload: params,
    };
  };
  
  export const getManualsList = (params, download,exportname) => {
    return {
      type: MANUAL_DATA,
      payload: params,
      exports: download,
      exportname:exportname
    };
  };
  export const manualListSuccess = (response) => {
    return {
      type: MANUAL_DATA_SUCCESS,
      payload: response,
    };
  };
  export const manualclinetListSuccess = (response) => {
    return {
      type: MANUAL_CLIENT_DATA_SUCCESS,
      payload: response,
    };
  };
  export const allManualListSuccess = (response) => {  
    return {
      type: ALL_MANUAL_DATA_SUCCESS,
      payload: response,
    };
  };
  
  export const ManualListError = (erordata) => {
    return {
      type: MANUAL_DATA_ERROR,
      payload: erordata,
    };
  };

  export const allCategoryListSuccess = (response) => {  

    return {
      type: CATEGORY_LIST_SUCCESS,
      payload: response,
    };
  };
  
  export const categoryListError = (response) => {  

    return {
      type: CATEGORY_LIST_ERROR,
      payload: response,
    };
  };
  export const fetchAllCategory = () => {
    return {
      type: ALL_CATEGORY_DATA_SUCCESS,
    };
  };
  export const allChangetypeListSuccess = (response) => {  

    return {
      type: CHANGETYPE_LIST_SUCCESS,
      payload: response,
    };
  };
  
  
  export const fetchAllChangetype = () => {
    return {
      type: ALL_CHANGETYPE_DATA,
    };
  };
  export const ChangetypeListError = (response) => {  

    return {
      type: CHANGETYPE_LIST_ERROR,
      payload: response,
    };
  };
  
  export const onAddnewManual = (params, callback) => {
    return {
      type: ADD_MANUAL,
      payload: params,
      callback,
    };
  };
  export const onAddnewManualSuccess = (response) => {
    return {
      type: ADD_MANUAL_SUCCESS,
      payload: response,
    };
  };
  export const onAddnewManualError = (erordata) => {
    return {
      type: ADD_MANUAL_ERROR,
      payload: erordata,
    };
  };
  export const onupdateManual = (params, callback) => {
    return {
      type: UPDATE_NEW_MANUAL,
      payload: params,
      callback,
    };
  };
  export const onupdateManualSuccess = (response) => {
    return {
      type: UPDATE_NEW_MANUAL_SUCCESS,
      payload: response,
    };
  };
  
  export const onupdateManualError = (erordata) => {
    return {
      type: UPDATE_NEW_MANUAL_ERROR,
      payload: erordata,
    };
  };
  export const onDeletemanual = (Id, callback) => {    
    return {
      type: DELETE_MANUAL_BYID,
      payload: Id,
      callback,
    };
  };
  export const onDeletemanualSuccess = (mess) => {
    return {
      type: DELETE_MANUAL_SUCCESS,
      payload: mess,
    };
  };
  
  export const onDeletemanualError = (mess) => {
    return {
      type: DELETE_MANUAL_ERROR,
      payload: mess,
    };
  };
  export const onAddnewDrawing = (params, callback) => {
    return {
      type: ADD_DRAWING,
      payload: params,
      callback,
    };
  };
  export const onAddnewDrawingSuccess = (response) => {
    return {
      type: ADD_DRAWING_SUCCESS,
      payload: response,
    };
  };
  export const OnAddnewDrawingError = (erordata) => {
    return {
      type: ADD_DRAWING_ERROR,
      payload: erordata,
    };
  };
  export const onupdateDrawing = (params, callback) => {
    return {
      type: UPDATE_NEW_DRAWING,
      payload: params,
      callback,
    };
  };
  export const onupdateDrawingSuccess = (response) => {
    return {
      type: UPDATE_NEW_DRAWING_SUCCESS,
      payload: response,
    };
  };
  
  export const onupdateDrawingError = (erordata) => {
    return {
      type: UPDATE_NEW_DRAWING_ERROR,
      payload: erordata,
    };
  };
  export const onDeleteDrawing = (Id, callback) => {
   
    return {
      type: DELETE_DRAWING_BYID,
      payload: Id,
      callback,
    };
  };
  export const onDeletedrawingSuccess = (mess) => {
    return {
      type: DELETE_DRAWING_SUCCESS,
      payload: mess,
    };
  };
  
export const onDeletedrawingError = (mess) => {
  return {
    type: DELETE_DRAWING_ERROR,
    payload: mess,
  };
};

export const getCategoryDrawingBysite = (params, download, exportname) => {
  return {
    type: CATEGORY_DRAWING_DATA,
    payload: params,
    exports: download,
    exportname: exportname
  };
};

export const CategorydrawinglistbysiteSucess = (response) => {
  return {
    type: CATEGORY_DRAWING_DATA_SUCCESS,
    payload: response,

  };
};
export const CategorydrawinglistbysiteError = (erordata) => {
  return {
    type: CATEGORY_DRAWING_DATA_ERROR,
    payload: erordata,
  };
};